export default __webpack_public_path__ + "static/media/redmi5.845ff188.jpg";